var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type !== "other" &&
      !_vm.$store.state.AdminTravelService.isOfferReadonly
        ? _c("v-checkbox", {
            attrs: {
              label: "Użyj edytora WYSIWYG tekstowego zamiast formularza"
            },
            nativeOn: {
              "!click": function($event) {
                $event.preventDefault()
                return _vm.setSimpleEditor($event)
              }
            },
            model: {
              value: _vm.contextServiceOffer.simpleEditor,
              callback: function($$v) {
                _vm.$set(_vm.contextServiceOffer, "simpleEditor", $$v)
              },
              expression: "contextServiceOffer.simpleEditor"
            }
          })
        : _vm._e(),
      _c(
        "v-row",
        [
          _vm.contextServiceOffer.simpleEditor
            ? _c(
                "v-col",
                { attrs: { md: "9", cols: "12" } },
                [
                  _c("custom-tinymce-editor", {
                    attrs: {
                      value: _vm.contextServiceOffer.html,
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly
                    },
                    on: {
                      "update:value": function($event) {
                        return _vm.$set(_vm.contextServiceOffer, "html", $event)
                      }
                    }
                  })
                ],
                1
              )
            : _c(
                "v-col",
                { attrs: { md: "9", cols: "12" } },
                [
                  _vm._l(_vm.contextServiceOffer.parts, function(
                    part,
                    partIndex
                  ) {
                    return _c(
                      "div",
                      { key: partIndex },
                      [
                        _vm.type === "flight"
                          ? _c(
                              "div",
                              [
                                _c("flight-form", {
                                  ref: "toValidate",
                                  refInFor: true,
                                  attrs: {
                                    "baggage-rules": [
                                      _vm.isBaggageFieldRequired
                                    ],
                                    part: part,
                                    "part-index": partIndex,
                                    "return-route-checkbox-rules": [
                                      function() {
                                        return _vm.validateIsReturnRouteSet(
                                          _vm.contextServiceOffer
                                        )
                                      }
                                    ],
                                    "show-return-checkbox":
                                      _vm.returnDate != null
                                  },
                                  on: {
                                    "update:part": function($event) {
                                      part = $event
                                    },
                                    returnRouteCheckboxReValidate:
                                      _vm.revalidateReturnRoute
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type === "low-cost"
                          ? _c(
                              "div",
                              [
                                _c("low-cost-form", {
                                  ref: "toValidate",
                                  refInFor: true,
                                  attrs: {
                                    "baggage-rules": [
                                      _vm.isBaggageFieldRequired
                                    ],
                                    part: part,
                                    "part-index": partIndex,
                                    "return-route-checkbox-rules": [
                                      function() {
                                        return _vm.validateIsReturnRouteSet(
                                          _vm.contextServiceOffer
                                        )
                                      }
                                    ],
                                    "show-return-checkbox":
                                      _vm.returnDate != null
                                  },
                                  on: {
                                    "update:part": function($event) {
                                      part = $event
                                    },
                                    returnRouteCheckboxReValidate:
                                      _vm.revalidateReturnRoute
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type === "car"
                          ? _c(
                              "div",
                              [
                                _c("car-form", {
                                  attrs: {
                                    part: part,
                                    "part-index": partIndex
                                  },
                                  on: {
                                    "update:part": function($event) {
                                      part = $event
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type === "rail"
                          ? _c(
                              "div",
                              [
                                _c("rail-form", {
                                  ref: "toValidate",
                                  refInFor: true,
                                  attrs: {
                                    part: part,
                                    "part-index": partIndex,
                                    "return-route-checkbox-rules": [
                                      function() {
                                        return _vm.validateIsReturnRouteSet(
                                          _vm.contextServiceOffer
                                        )
                                      }
                                    ],
                                    "show-return-checkbox":
                                      _vm.returnDate != null
                                  },
                                  on: {
                                    "update:part": function($event) {
                                      part = $event
                                    },
                                    returnRouteCheckboxReValidate:
                                      _vm.revalidateReturnRoute
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type === "hotel"
                          ? _c(
                              "div",
                              [
                                _c("hotel-form", {
                                  attrs: { "part-index": partIndex, part: part }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.$store.state.AdminTravelService.isOfferReadonly
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "lighten-2",
                                staticStyle: {
                                  position: "relative",
                                  top: "-45px"
                                },
                                attrs: {
                                  button: "",
                                  color: "grey",
                                  fab: "",
                                  small: ""
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.removeServicePart(partIndex)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("remove")])],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  !_vm.$store.state.AdminTravelService.isOfferReadonly
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: {
                            position: "relative",
                            top: "-84px",
                            right: "-40px"
                          },
                          attrs: {
                            button: "",
                            color: "primary",
                            fab: "",
                            small: ""
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.addServicePart(_vm.contextServiceOffer)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("add")])],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
          _c("v-spacer"),
          _c(
            "v-col",
            { attrs: { md: "2", cols: "12" } },
            [_vm._t("default")],
            2
          ),
          typeof _vm.removeServiceFunction === "function" &&
          !_vm.$store.state.AdminTravelService.isOfferReadonly
            ? _c(
                "v-btn",
                {
                  staticClass: "hidden-md-and-up",
                  on: {
                    click: function($event) {
                      return _vm.removeServiceFunction(_vm.serviceOffer)
                    }
                  }
                },
                [_vm._v(" Usuń aktualną opcję ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.type === "low-cost"
        ? _c(
            "fieldset",
            { staticClass: "custom-fieldset" },
            [
              _c("legend", [_vm._v("Załącz formułki dotyczące")]),
              _c(
                "v-row",
                [
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "Rayanair"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_rayanair,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_rayanair", $$v)
                      },
                      expression: "contextServiceOffer.is_rayanair"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "Wizz Air"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_wizz_air,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_wizz_air", $$v)
                      },
                      expression: "contextServiceOffer.is_wizz_air"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "Norwegian"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_norwegian,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_norwegian", $$v)
                      },
                      expression: "contextServiceOffer.is_norwegian"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "easyJet"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_easy_jet,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_easy_jet", $$v)
                      },
                      expression: "contextServiceOffer.is_easy_jet"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "Germanwings / Eurowings"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_germanwings,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_germanwings", $$v)
                      },
                      expression: "contextServiceOffer.is_germanwings"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "Vueling"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_vueling,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_vueling", $$v)
                      },
                      expression: "contextServiceOffer.is_vueling"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly,
                      label: "Jet 2"
                    },
                    model: {
                      value: _vm.contextServiceOffer.is_jet2,
                      callback: function($$v) {
                        _vm.$set(_vm.contextServiceOffer, "is_jet2", $$v)
                      },
                      expression: "contextServiceOffer.is_jet2"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }